var _path, _path2, _path3, _path4, _path5;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPieChart = function SvgPieChart(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#A7D9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1237 9.82398L14.4586 16.5341L14.1521 16.3672L11.4375 8.92961L11.5576 8.58594C12.4623 8.25523 13.4395 8.0752 14.4586 8.0752C16.1501 8.0752 17.725 8.57223 19.047 9.42715C19.1802 9.51328 19.2143 9.69367 19.1237 9.82398Z",
    fill: "#EBF0F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4589 16.5341L14.2523 16.84L6.80512 19.2179L6.39879 19.1076C6.13977 18.2959 6 17.4315 6 16.5341C6 12.8859 8.30969 9.77703 11.5462 8.58996L11.5579 8.58594L14.4589 16.5341Z",
    fill: "#A7D9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6308 16.5342C22.7893 16.5342 22.918 16.6648 22.9127 16.8233C22.7602 21.3612 19.0336 24.9931 14.4586 24.9931C10.6843 24.9931 7.48723 22.5211 6.39844 19.1077L14.4586 16.5342H22.6308Z",
    fill: "#579FD7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2106 8.12065L17.8537 14.3874C17.7237 14.5744 17.8575 14.8304 18.0852 14.8304H25.7178C25.8765 14.8304 26.0052 14.6994 25.9998 14.5408C25.9106 11.8885 24.6 9.54612 22.6129 8.05721C22.4845 7.96092 22.3022 7.98889 22.2106 8.12065Z",
    fill: "#FCD462"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPieChart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pie_chart.a6c854f7.svg";
export { ForwardRef as ReactComponent };